export default {
  objectList: "/customer/Index/ObjcetList", //标的物列表,
  ObjectFailureList: "/customer/Index/ObjcetListFailure", // 流拍寻宝列表
};
